import styles from './index.module.scss';
import formatBytes from '../../assets/formatBytes';
import PercentageBar from './PercentageBar';
import { FileSystemContext } from '../FileSystem';
import { useContext } from 'react';

const UsagePanel: React.FC = () => {
  const [files] = useContext(FileSystemContext).useFiles();
  return (
    <div className={styles.UsagePanel}>
      <div className="usage">
        <h2>
          {formatBytes(
            files.map((file) => parseInt(file.size)).reduce((a, b) => a + b, 0)
          )}
        </h2>
        <PercentageBar files={files} />
      </div>
      <div className="file-categories">
        <div className="images">
          <i className="fas fa-file-image"></i>
          <p>Images</p>
        </div>
        <div className="videos">
          <i className="fas fa-file-video"></i>
          <p>Videos</p>
        </div>
        <div className="documents">
          <i className="fas fa-file-alt"></i>
          <p>Documents</p>
        </div>
        <div className="others">
          <i className="fas fa-file"></i>
          <p>Unknown</p>
        </div>
      </div>
    </div>
  );
};

export default UsagePanel;
